import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign "ResizeObserver loop completed with undelivered
// notifications" warning that React/CRA's dev error overlay treats as an
// error. It's fired by well-behaved libraries (Radix, cmdk) whenever they
// measure content during a layout pass and does not affect functionality.
//
// We hook in the CAPTURE phase (third arg = true) so this listener runs
// BEFORE CRA's dev-error-overlay listener, giving us the chance to stop
// propagation and prevent the red banner. We also monkey-patch
// ResizeObserver to swallow the exception at the source, which handles the
// path where React re-throws it inside an internal handler that bypasses
// the standard error event.
const RESIZE_OBSERVER_ERR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

const swallow = (e) => {
  const msg = e?.message || e?.reason?.message || String(e?.reason || "");
  if (RESIZE_OBSERVER_ERR.test(msg)) {
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
    return true;
  }
  return false;
};
window.addEventListener("error", swallow, true);
window.addEventListener("unhandledrejection", swallow, true);

// Wrap ResizeObserver so any exception inside its callback is caught
// silently instead of bubbling up to the dev overlay.
if (typeof window.ResizeObserver !== "undefined") {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (err) {
            if (!RESIZE_OBSERVER_ERR.test(String(err?.message || err))) {
              throw err;
            }
          }
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
